import type { ThemePageType } from '~/types/graphql';

import { useThemePageDuplicateMutation } from '~/api/graphql/mutations/themePageDuplicate.generated';
import { useThemePageUpdateMutation } from '~/api/graphql/mutations/themePageUpdate.generated';
import { useQueryThemeInfo } from '~/modules/apps';

export const useHandleDuplicateThemePage = () => {
  const { themeId } = useQueryThemeInfo();

  const duplicateThemePageMutation = useThemePageDuplicateMutation();
  const updateThemePageMutation = useThemePageUpdateMutation();
  const handleDuplicateThemePage = async ({
    id,
    type,
    name,
    duplicateAsIndependent = false,
  }: {
    id: string;
    type: ThemePageType;
    name: string;
    duplicateAsIndependent?: boolean;
  }) => {
    if (!id || !themeId) return;
    try {
      const { themePageDuplicate } = await duplicateThemePageMutation.mutateAsync({
        id,
        type,
        name,
        themeID: themeId,
      });

      if (!themePageDuplicate?.id) return;

      if (duplicateAsIndependent) return themePageDuplicate;

      await updateThemePageMutation.mutateAsync({
        id: themePageDuplicate?.id ?? '',
        input: {
          parentID: id,
        },
      });
      return themePageDuplicate;
    } catch (error) {
      console.error(error);
      throw new Error('Failed to duplicate theme page');
    }
  };
  return {
    handleDuplicateThemePage,
  };
};
